<template>
  <div v-if="cgiInfo && cgiInfo.ret === 0" class="dialog">
    <div class="dialog-bg"></div>
    <div class="lol-effect-eat">
      <div class="lol-effect-title">
        <span @click="closeStarRating"><img src="../../../../ui/assets/mobile/images/dialog-close--bold.png" alt="" /></span>
        <h4>{{ starTitle }}</h4>
      </div>
      <div v-if="starDesc" class="new--module active-cost lol-info-box">
        <div class="lol-info">
          <span class="lol-info-l">{{ starDesc }}</span>
        </div>
      </div>
      <p class="eva-title">
        {{ rated ? "再次点击星星可以更新您的评分" : "请点击星星评分" }}
      </p>
      <div class="eva-right">
        <div v-for="(item, index) in dimensionList" :key="index" class="star-item">
          <p>{{ item.desc }}</p>
          <ul @click.stop.prevent="tapStar">
            <li
              v-for="(star, key) in [1, 2, 3, 4, 5]"
              :key="key"
              :data-star="star"
              :data-index="index"
              :class="item.score * 1 >= star ? '' : 'gray-star'"
            ></li>
          </ul>
          <span>{{ STAR_REMARK[Math.round(dimensionList[index].score * 1)] }}</span>
        </div>
        <!-- 修改评分 -->
        <div class="eva-btn" :class="!changed ? 'bottom-btn--disabled' : ''" @click="submitStarRating">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onBeforeMount, computed } from "@vue/composition-api"
import { StarRatingApi } from "../../../api/starRating"
import _ from "lodash"
import { STAR_REMARK } from "../../../store/enums"
import { CLICK, PAGE_VIEW } from "../../../constants/report-dictonary"

const toastMsgs = {
  SYSTEM_BUSY: "系统繁忙，请稍后再试",
  RATE_SUCCESS: "评分成功",
  NOT_COMPLETE: "尚有未完成的评分",
  LOADING: "查询评分中，请稍等"
}

export default {
  props: ["subjectId", "subjectType", "offerId", "starTitle", "starDesc", "zoneParams", "scoreFactor", "pfStructure"],

  setup(props, { root, emit }) {
    const state = reactive({
      cgiInfo: null,
      dimensionList: [],

      // 判断用户是第一次评分还是之前评分过
      rated: computed(() => {
        if (state.cgiInfo) {
          return state.cgiInfo.data.dimension_score.some(item => item.score !== "")
        }

        return false
      }),

      // 判断用户是否更改了星星的内容
      changed: computed(() => {
        if (state.cgiInfo) {
          return _.some(state.dimensionList, (item, index) => {
            return item.score * 1 !== Math.round((state.cgiInfo.data.dimension_score[index].score * 1) / props.scoreFactor)
          })
        }

        return false
      }),

      factor: computed(() => {
        return props.scoreFactor ? props.scoreFactor * 1 : 1
      })
    })

    let { pf, sandbox } = root.$store.state

    // 获取接口调用接口
    let starRatingObj = new StarRatingApi({
      pf,
      sandbox,
      sessionObj: root.$store.getters.sessionObj,
      offerId: props.offerId
    })

    // 获得 cgi 评分结果
    onBeforeMount(async () => {
      root.$store.dispatch("setLoadingStart")

      // 有资格后，请求评分接口接口
      state.cgiInfo = await starRatingObj.queryUserStarRating({
        subject_id: props.subjectId,
        subject_type: props.subjectType,
        score_factor: state.factor
      })

      root.$store.dispatch("setLoadingEnd")

      if (state.cgiInfo.ret !== 0) {
        root.$store.dispatch("setToastMsg", toastMsgs.SYSTEM_BUSY)
        return
      }

      state.dimensionList = state.cgiInfo.data.dimension_score.map(item => {
        return {
          ...item,
          score: Math.round((item.score * 1) / state.factor)
        }
      })

      // 上报用户行为
      reportUserAction(PAGE_VIEW.STAR_RATE_DIALOG_SHOW)
    })

    // 用户点击评分图标
    const tapStar = e => {
      let { index, star } = e.target.dataset

      if (!star) {
        return
      }

      state.dimensionList[index].score = star

      reportUserAction(CLICK.RATE_CLICK_STAR)
    }

    // 关闭评分弹窗
    const closeStarRating = () => {
      emit("toggleRateDialog")
    }

    // 用户评分或者修改评分
    const submitStarRating = async () => {
      reportUserAction(CLICK.RATE_SUBMIT_STAR)

      // 评分未修改，则拦截
      if (!state.changed) {
        reportUserAction(PAGE_VIEW.DETAIL_RATE_NOT_CHANGED)
        return
      }

      if (state.dimensionList.some(item => !item.score)) {
        root.$store.dispatch("setToastMsg", toastMsgs.NOT_COMPLETE)
        reportUserAction(PAGE_VIEW.DETAIL_DIMENSION_LACK)
        return
      }

      let dimension_score = state.dimensionList.map(item => `${item.dimension}:${parseInt(item.score)}`)

      let params = {
        subject_id: props.subjectId,
        subject_type: props.subjectType,
        dimension_score,
        score_factor: state.factor
      }

      // 判断是否有大区信息
      if (props.zoneParams) {
        params = {
          ...params,
          ...props.zoneParams
        }
      }

      let ratingRes = await starRatingObj.starRating(params)

      if (ratingRes.ret !== 0) {
        let errMsg = ratingRes.err_code ? toastMsgs.SYSTEM_BUSY : ratingRes.msg

        root.$store.dispatch("setToastMsg", errMsg)
        return
      }

      // 评星成功，且环比当前的评分弹窗
      emit("success", ratingRes?.data?.score)
      closeStarRating()
    }

    // 统一上报接口
    const reportUserAction = iformat => {
      root.$store.dispatch("reportUserAction", {
        iformat,
        resultInfo: {
          subjectType: props.subjectType,
          subjectId: props.subjectId,
          type: state.rated ? 1 : 0
        },
        pfStructure: props.pfStructure || ""
      })
    }

    return {
      ...toRefs(state),
      submitStarRating,
      tapStar,
      closeStarRating,
      STAR_REMARK
    }
  }
}
</script>
